'use client';
import { Navigation, Pagination, A11y, Thumbs, Autoplay } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import './SwiperCarousel.scss';

import 'swiper/scss';
import 'swiper/scss/navigation';
import 'swiper/scss/pagination';
import 'swiper/scss/scrollbar';
import React, { Children, FC, ReactNode, useCallback, useEffect, useState } from 'react';

interface Props {
    children: ReactNode;
    config: {
        autoplay?: boolean;
        withArrowButtons?: boolean;
        paginationDotColor?: string;
        multiCard?: boolean;
        type?: 'insights' | 'caseStudies' | 'default';
    };
}

const LARGE_SCREEN_WIDTH = 991;
const MEDIUM_SCREEN_WIDTH = 768;
const SwiperCarousel: FC<Props> = ({ children, config }) => {
    const [numberOfVisibleCards, setNumberOfVisibleCards] = useState<number>(1);

    const {
        autoplay = true,
        withArrowButtons = true,
        paginationDotColor = '#4b4f54',
        multiCard = false,
        type = 'default',
    } = config;

    const updateVisibleCards = useCallback(() => {
        if (multiCard && type === 'caseStudies') {
            const width = window.innerWidth;
            if (width >= LARGE_SCREEN_WIDTH) {
                setNumberOfVisibleCards(4);
            } else if (width >= MEDIUM_SCREEN_WIDTH) {
                setNumberOfVisibleCards(3);
            } else {
                setNumberOfVisibleCards(1);
            }
        }
        if (multiCard && type === 'insights') {
            const width = window.innerWidth;
            if (width >= LARGE_SCREEN_WIDTH) {
                setNumberOfVisibleCards(3);
            } else {
                setNumberOfVisibleCards(1);
            }
        }
    }, [multiCard, type]);

    useEffect(() => {
        updateVisibleCards();
        window.addEventListener('resize', updateVisibleCards);
        return () => window.removeEventListener('resize', updateVisibleCards);
    }, [multiCard, updateVisibleCards]);
    return (
        <Swiper
            modules={[Pagination, Thumbs, Autoplay, Navigation, A11y]}
            spaceBetween={multiCard ? 25 : 0}
            slidesPerView={numberOfVisibleCards}
            loop
            autoplay={
                autoplay
                    ? {
                          delay: 2500,
                          disableOnInteraction: true,
                          pauseOnMouseEnter: true,
                      }
                    : false
            }
            navigation={withArrowButtons}
            pagination={{ clickable: true }}
        >
            {Children.toArray(children).map((child, index) => (
                <SwiperSlide key={`swiper-carousel-slide-${index}`}>{child}</SwiperSlide>
            ))}
        </Swiper>
    );
};

export default SwiperCarousel;
